"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validator_1 = __importDefault(require("validator"));
const enums_1 = require("./enums");
const dayjs = require("dayjs");
class ProtoUtil {
    static decodeStruct(struct) {
        if (!struct || Object.keys(struct).length === 0 || !struct.fields) {
            return null;
        }
        const { fields } = struct;
        const json = {};
        Object.keys(fields).forEach((key) => {
            json[key] = ProtoUtil.decodeValue(fields[key]);
        });
        return json;
    }
    static decodeList({ values }) {
        if (!values) {
            return [];
        }
        return values.map(ProtoUtil.decodeValue);
    }
    static decodeValue(value) {
        const kind = ProtoUtil.getValueKind(value);
        switch (kind) {
            case enums_1.Values.listValue:
                return ProtoUtil.decodeList(value.listValue);
            case enums_1.Values.structValue:
                return ProtoUtil.decodeStruct(value.structValue);
            case enums_1.Values.nullValue:
                return null;
            default:
                return value[kind];
        }
    }
    static encodeStruct(json) {
        if (!json || Object.keys(json).length === 0) {
            return null;
        }
        const fields = {};
        Object.keys(json).forEach((key) => {
            if (typeof json[key] === 'undefined') {
                return;
            }
            if (json[key]
                && typeof json[key] === 'object'
                && Object.keys(json[key]).length === 0
                && !(json[key] instanceof Date)) {
                json[key] = null;
            }
            fields[key] = ProtoUtil.encodeValue(json[key]);
        });
        return { fields };
    }
    static encodeList(values) {
        return {
            values: values.map(ProtoUtil.encodeValue),
        };
    }
    static encodeValue(value) {
        const type = ProtoUtil.typeOf(value);
        const encoder = ProtoUtil.getEncoder(type);
        return encoder(value);
    }
    static encodeString(value) {
        const isIsoString = validator_1.default.isISO8601(value, { strict: true });
        const numberValue = parseInt(value, 10);
        const isNumeric = validator_1.default.isNumeric(value);
        if (isNaN(numberValue) || isNumeric) {
            return value;
        }
        if (isIsoString) {
            return dayjs(value).toISOString();
        }
        return value;
    }
    static getEncoder(type) {
        const encoders = {
            [ProtoUtil.typeOf({})]: (v) => ProtoUtil.wrap('structValue', ProtoUtil.encodeStruct(v)),
            [ProtoUtil.typeOf([])]: (v) => ProtoUtil.wrap('listValue', ProtoUtil.encodeList(v)),
            [ProtoUtil.typeOf(0)]: (v) => ProtoUtil.wrap('numberValue', v),
            [ProtoUtil.typeOf('')]: (v) => ProtoUtil.wrap('stringValue', ProtoUtil.encodeString(v)),
            [ProtoUtil.typeOf(true)]: (v) => ProtoUtil.wrap('boolValue', v),
            [ProtoUtil.typeOf(null)]: () => ProtoUtil.wrap('nullValue', 0),
            [ProtoUtil.typeOf(new Date())]: (v) => ProtoUtil.wrap('stringValue', dayjs(v).toISOString()),
        };
        if (typeof encoders[type] !== 'function') {
            throw new TypeError(`No registered encoder for type: ${type}`);
        }
        return encoders[type];
    }
    static wrap(kind, value) {
        return { [kind]: value };
    }
    static typeOf(value) {
        return toString.call(value);
    }
    static getValueKind(value) {
        let valueKind = enums_1.Values.nullValue;
        const valueKeys = Object.keys(value);
        valueKeys.forEach((prop) => {
            if (prop in value) {
                valueKind = prop;
            }
        });
        return valueKind;
    }
}
exports.default = ProtoUtil;
